<div [ngClass]="['mega-card', cardType, status]">
    <!-- Badge -->
    <div *ngIf="badgeText" class="badge">{{ badgeText }}</div>
  
    <!-- Background Image -->
    <div class="card-bg" [ngStyle]="{'background-image': 'url(' + imageUrl + ')'}"></div>
  
    <!-- Content -->
    <div class="card-content">
      <h3 class="title">{{ title }}</h3>
      <p class="description">{{ description }}</p>
  
      <!-- Lock Icon for Locked Content -->
      <div *ngIf="cardType === 'locked'" class="lock-icon">
        🔒
      </div>
  
      <!-- Status Badge -->
      <div *ngIf="cardType === 'premium'" class="status-badge" [ngClass]="status">
        {{ status | uppercase }}
      </div>
  
      <!-- Call to Action Button -->
      <button (click)="onCtaClick()" [disabled]="status === 'paid' && cardType !== 'promo'">
        {{ ctaText }}
      </button>
    </div>
</div>